// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1kQP3","bigColWidth":"Table_bigColWidth__3KvZ5","biggerColWidth":"Table_biggerColWidth__1RUuQ","row":"Table_row__3CbUc","col":"Table_col__155Nt"};